export const timeAgo = (date) => {
  const now = new Date();
  const pastDate = new Date(+date);
  const differenceInMs = now - pastDate;

  const seconds = Math.floor((differenceInMs / 1000) % 60);
  const minutes = Math.floor((differenceInMs / 1000 / 60) % 60);
  const hours = Math.floor((differenceInMs / (1000 * 60 * 60)) % 24);
  const days = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));
  const months = Math.floor(days / 30); // Approximate months
  const years = Math.floor(days / 365); // Approximate years

  if (years > 0) {
    return years + "y";
  } else if (months > 0) {
    return months + "mo";
  } else if (days > 0) {
    return days + "d";
  } else if (hours > 0) {
    return hours + "h";
  } else if (minutes > 0) {
    return minutes + "m";
  } else if (seconds > 0) {
    return seconds + "s";
  } else {
    return "Just now";
  }
};

export const publishedDate = (date) => {
  const formattedDate = new Date(+date).toLocaleString("en-US", {
    // weekday: "long",
    // day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
    timeZoneName: "short",
  });
  return formattedDate.replace("AM", "am").replace("PM", "pm").replace("GMT+5:30", "IST");
};

function MagformatDate(date) {
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
  };
  const formattedDate = new Date(date).toLocaleDateString("en-US", options);
  return formattedDate;
}
function formatDate(date) {
  const options = {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };
  const formattedDate = new Date(date).toLocaleDateString("en-US", options);
  return formattedDate;
}

export const publishedAndUpdatedDate = (publishedDate, updatedDate) => {
  console.log(publishedDate, updatedDate);
  const published = new Date(publishedDate);
  console.log(published);
  const updated = new Date(updatedDate);
  const formattedPublished = formatDate(published);
  console.log(formattedPublished);
  const formattedUpdated = formatDate(updated);
  const isSameDate = published.toDateString() === updated.toDateString();
  if (isSameDate) {
    return `${formattedPublished} | Updated ${formattedUpdated.split(",").slice(-1)} IST`;
  } else {
    return `${formattedPublished} | Updated ${formattedUpdated} IST`;
  }
};

export const MagPublishedDate = (publishedDateData) => {
  const publishedDate = Number(publishedDateData);

  const published = new Date(publishedDate);
  const formattedPublished = MagformatDate(published);

  return formattedPublished;
};

// export const nowTime = () => {
//   const now = new Date();
//   const options = {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//     timeZone: "Asia/Kolkata",
//   };

//   return now.toLocaleString("en-US", options);
// };

// export const publishAtInStandardFormat = (date) => {
//   const formattedDate = new Date(+date).toLocaleString("en-US", {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "numeric",
//     minute: "2-digit",
//     hour12: true,
//     timeZone: "Asia/Kolkata",
//   });

//   return formattedDate.replace("GMT+5:30", "IST");
// };
